//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty, transform } from "lodash";
import { rules } from "@Shared/@Utils/shared-mixins/vuelidate-valid-mixin";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SectionError",
  inject: {
    $validator: {
      default: null
    }
  },
  props: {
    errorMessage: {
      type: String,
      default: ""
    },
    tag: {
      type: String,
      default: "span"
    },
    validator: {
      type: null,
      default: null
    },
    icon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    inline() {
      return !isEmpty(this.$slots.default);
    },
    validation() {
      var _this$$validator;
      if (this.errorMessage || !this.inline) return {};
      if (this.validator) return this.validator;
      return ((_this$$validator = this.$validator) == null ? void 0 : _this$$validator.value) || {};
    },
    displayError() {
      const {
        displayError
      } = transform(rules, (acc, value, rule) => {
        if (this.validation[rule] === false) {
          const isSoft = this.isSoftError(rule);
          acc.displayError = {
            isSoft,
            value: this.getErrorMessage(rule, value, isSoft ? "soft" : "full")
          };
        }
        if (acc.displayError) {
          // stop at first rule found
          return false;
        }
      }, {});
      return {
        isSoft: displayError == null ? void 0 : displayError.isSoft,
        message: displayError == null ? void 0 : displayError.value
      };
    },
    message() {
      return this.displayError.message;
    },
    isSoft() {
      return this.displayError.isSoft;
    }
  },
  watch: {
    "validation.$model"() {
      if (!this.validation.$dirty) this.setDirty();
    }
  },
  methods: {
    isSoftError(rule) {
      var _this$validation$$par, _this$validation$$par2;
      if (isEmpty(this.validation)) return false;
      return (_this$validation$$par = (_this$validation$$par2 = this.validation.$params[rule]) == null ? void 0 : _this$validation$$par2.softError) != null ? _this$validation$$par : false;
    },
    getErrorMessage(rule, value, key) {
      if (typeof value[key] === "function") return value[key](this.validation.$params[rule]);
      return value[key];
    },
    setDirty() {
      var _this$validation$$tou, _this$validation;
      (_this$validation$$tou = (_this$validation = this.validation).$touch) == null ? void 0 : _this$validation$$tou.call(_this$validation);
    }
  }
});